<template>
<v-container fluid class="pt-3" style="max-width: 600px; padding: 0">
  <v-row justify="center">
    <v-col cols="12">
      <v-card class="grey lighten-5 pa-10" justify="center" elevation="12">
        <v-card-title class="justify-center">
          <strong>
            This invoice has been paid.
          </strong>
        </v-card-title>
        <p class="text-center">
          Should you have any questions, please contact {{branding.firstName}} {{branding.lastName}}<br>
          <a :href="`tel:${branding.phone}`">
              {{branding.phone}}
          </a>
          <br>
          <a :href="`mailto:${branding.email}`">
              {{branding.email}}
          </a>
        </p>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    invoiceNumber: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['branding']),
  },
});
</script>
